import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import MethodGet from "../../../../src/Config/Services";
const SelectMunicipality = (props) => {
  const detectarCambiosMunicipality = (value) => {
    props.detectarCambiosMunicipality(value);
  };
  const [municipalities, saveMunicipalities] = useState([]);
  useEffect(() => {
    if (props.state_id) {
      let url = `/municipalities/${props.state_id}`;
      MethodGet(url)
        .then((res) => {
          saveMunicipalities(res.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [props.state_id]);
  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
  };
  return (
    <>
      <Select
        label="Selecciona un Municipio"
        autofocus
        placeholder="Selecciona un Municipio"
        options={municipalities.map((muni) => {
          let attribute = {
            label: muni.name,
            value: muni.id,
          };
          return attribute;
        })}
        styles={selectStyles}
        onChange={(value) => detectarCambiosMunicipality(value)}
      />
    </>
  );
};

export default SelectMunicipality;
